import dayjs from 'dayjs';
import { useSelectedSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import { getDaysDifference } from '../../../utils/dateCalculations';
import styles from './Months.module.scss';

export const Months = () => {
  const schoolYear = useSelectedSchoolYear();
  const start = dayjs(schoolYear?.start);
  const end = dayjs(schoolYear?.end);
  const totalDays = getDaysDifference(start, end);

  // Monate direkt aus den echten Datumswerten iterieren. Pro Monat wird die
  // tatsächliche Überlappung mit dem Schuljahr in Tagen gezählt und auf
  // totalDays normiert -> Schaltjahre/Jahreswechsel sind automatisch korrekt
  // und die Breiten summieren sich exakt auf 100 % (deckungsgleich zur Heute-Linie).
  const months: { label: string; widthPercent: number }[] = [];
  let cursor = start;
  while (cursor.isSameOrBefore(end, 'day')) {
    const monthEnd = cursor.endOf('month');
    const segmentEnd = monthEnd.isAfter(end) ? end : monthEnd;
    const days = getDaysDifference(cursor, segmentEnd);
    months.push({
      label: cursor.toDate().toLocaleString('default', { month: 'short' }),
      widthPercent: (days / totalDays) * 100,
    });
    cursor = monthEnd.add(1, 'day');
  }

  return (
    <div className={styles.months}>
      {months.map(({ label, widthPercent }, index) => (
        <div key={index} className={styles.month} style={{ width: `${widthPercent}%` }}>
          {label}
        </div>
      ))}
    </div>
  );
};
